module.exports = __webpack_public_path__ + "1.4.15-unryo/img/rabbitmq.3938d65c.svg";